import { render, staticRenderFns } from "./AdsTermAndConditionModal.vue?vue&type=template&id=0ba0b4fc&scoped=true"
import script from "./AdsTermAndConditionModal.vue?vue&type=script&lang=js"
export * from "./AdsTermAndConditionModal.vue?vue&type=script&lang=js"
import style0 from "./AdsTermAndConditionModal.vue?vue&type=style&index=0&id=0ba0b4fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0b4fc",
  null
  
)

export default component.exports